import React, { FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import { StartTimeInfo } from './components/StartTimeInfo/StartTimeInfo'
import { VideoInfo } from './components/VideoInfo/VideoInfo'
import { VideoThumbnail } from './components/VideoThumbnail/VideoThumbnail'

import classes from './VideoItem.module.scss'
import { FooterInfo } from './components/FooterInfo/FooterInfo'

type VideoItemProps = {
  item: FeedData
}

export const VideoItem: FC<VideoItemProps> = ({ item }) => {
  return (
    <div className={classes.Container}>
      <div className={classes.Body}>
        <VideoThumbnail imgSrc={item.thumbnailImageUrl} />
        <div className={classes.Info}>
          <StartTimeInfo startTime={item.startTime || item.publishedAt} />
          <VideoInfo title={item.title} />
        </div>
      </div>
      <FooterInfo game={item} />
    </div>
  )
}
